import { colors } from '@core/assistant/colors';

export const useStyles = () => {
  return {
    tag: {
      color: colors.white,
      background: colors.myta,
      fontSize: 8,
      lineHeight: 1,
      borderRadius: '3px',
      padding: 0.5,
      height: 'fit-content',
    },
  };
};
